import { ClipLoader } from 'react-spinners';
import styles from './HydrateFallback.module.css';

const HydrateFallback = () => {
	return (
		<div className={styles.container}>
			<ClipLoader size="10rem" />
		</div>
	);
};

export default HydrateFallback;
